module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "md-notification col-xs-11 col-sm-3 alert open",
    class: [_vm.placement.from, _vm.placement.align, ("alert-" + _vm.type), _vm.withIcon],
    style: (_vm.customPosition),
    attrs: {
      "data-notify": "container",
      "role": "alert",
      "data-notify-position": "top-center"
    }
  }, [(_vm.allowDismiss) ? _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-hidden": "true",
      "data-notify": "dismiss"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("×")]) : _vm._e(), (!!_vm.icon) ? _c('i', {
    staticClass: "fas alert-icon",
    class: "fa-" + _vm.icon
  }) : _vm._e(), (!!_vm.title) ? _c('span', {
    attrs: {
      "data-notify": "title"
    }
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._t("message", [(!!_vm.message) ? _c('span', {
    attrs: {
      "data-notify": "message"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.message)
    }
  }) : _vm._e()]), (_vm.progressbar) ? _c('div', {
    staticClass: "progress",
    attrs: {
      "data-notify": "progressbar"
    }
  }, [_c('div', {
    staticClass: "progress-bar `progress-bar-${type}`",
    staticStyle: {
      "width": "0%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "0",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })]) : _vm._e(), (!!_vm.url) ? _c('a', {
    attrs: {
      "href": "url",
      "target": "target",
      "data-notify": "url"
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d8ce598","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/core/components/mdNotification/index.vue
// module id = naIp
// module chunks = 13 14